<template>
 <div class="row">
  <div class="col-sm-12">
   <form
    id="file-upload-form"
    class="uploader mb-3"
   >
    <input
     type="file"
     id="file-upload"
     multiple
     @change="uploadFile"
     class="form-control"
    />
    <label
     for="file-upload"
     id="file-drag"
     @drop="droppedFile"
     @dragover="$event.target.classList.add('dropping')"
     @mouseout="$event.target.classList.remove('dropping')"
     @dragleave="$event.preventDefault(), $event.target.classList.remove('dropping')"
    >
     <div id="start">
      <font-awesome-icon icon="upload" />
      <div class="mb-2">Selecteer een bestand of drag and drop hier</div>
      <span
       id="file-upload-btn my-3"
       class="btn btn-primary"
      >Selecteer een bestand</span>
     </div>
    </label>
   </form>
  </div>
 </div>
</template>

<script>
import parser from "fast-xml-parser";
import School from "../models/school";
import Groep from "../models/group";
import SamengesteldeGroep from "../models/composedGroup";
import Leerling from "../models/pupil";
import Leerkracht from "../models/teacher";

export default {
 name: "Home",
 data() {
  return {
   filelist: null,
  };
 },
 methods: {
  checkFile() {
   const allowedFiles = ["text/xml", "application/xml", "application/json"];
   if (allowedFiles.includes(this.filelist[0].type)) {
    this.openFile();
   } else {
    this.$toast.error("Alleen XML en JSON bestanden zijn toegestaan");
   }
  },
  uploadFile(e) {
   this.filelist = e.target.files;
   this.checkFile();
  },
  droppedFile(e) {
   this.filelist = e.dataTransfer.files;

   this.checkFile();
  },
  openFile() {
   const options = {
    attributeNamePrefix: "",
    attrNodeName: "key",
    ignoreAttributes: false,
    textNodeName: "naam",
    numParseOptions: {
     leadingZeros: false,
    },
   };

   const file = this.filelist[0];
   const reader = new FileReader();
   reader.addEventListener("load", (event) => {
    const fileContent = event.target.result;
    if (file.type === "text/xml") {
     this.remodelXMLContent(parser.parse(fileContent, options));
    } else if (file.type === "application/json") {
     this.remodelJSONContent(fileContent);
    }
   });
   reader.readAsText(file);
  },
  remodelXMLContent(data) {
   if (data.leerlinggegevens || data["le:leerlinggegevens"] || data.EDEX) {
    data = data.leerlinggegevens || data["le:leerlinggegevens"] || data.EDEX;

    if (data.key) {
     delete data.key;
    }

    // clone data to workable content
    let content = { ...data };

    //-----------------school
    if (data.school) {
     content.school = new School(content.school);
    } else {
     content.school = new School();
     this.$toast.info("Geen Schoolgegevens ingelezen");
    }

    //-----------------groups
    content.groepen = { groep: [], samengestelde_groep: [] };
    if (data.groepen) {
     if (!Array.isArray(data.groepen.groep)) {
      data.groepen.groep = [data.groepen.groep];
     }
     const groups = data.groepen.groep;

     groups.forEach((group) => {
      const tempKey = group.key.key;
      group.key = tempKey;
      content.groepen.groep.push(new Groep(group));
     });
    } else {
     this.$toast.info("Geen Groepen ingelezen");
    }

    //-----------------Composed groups (subgroepen)
    if (data.subgroepen) {
     if (!Array.isArray(data.subgroepen.subgroep)) {
      data.subgroepen.subgroep = [data.subgroepen.subgroep];
     }
     const subgroups = data.subgroepen.subgroep;

     subgroups.forEach((subgroup) => {
      const tempKey = subgroup.key.key;
      subgroup.key = tempKey;
      content.groepen.samengestelde_groep.push(
       new SamengesteldeGroep(subgroup)
      );
     });
     delete content.subgroepen;
    } else {
     // TODO: initialize empty subgroup
    }

    //-----------------Composed groups (samengestelde groepen)
    if (data.groepen.samengestelde_groep) {
     if (!Array.isArray(data.groepen.samengestelde_groep)) {
      data.groepen.samengestelde_groep = [data.groepen.samengestelde_groep];
     }

     const subgroups = data.groepen.samengestelde_groep;

     subgroups.forEach((subgroup) => {
      const tempKey = subgroup.key.key;
      subgroup.key = tempKey;
      content.groepen.samengestelde_groep.push(
       new SamengesteldeGroep(subgroup)
      );
     });
    } else {
     // TODO: initialize empty subgroup
    }

    //-----------------Pupils
    content.leerlingen = { leerling: [] };
    if (data.leerlingen) {
     if (!Array.isArray(data.leerlingen.leerling)) {
      data.leerlingen.leerling = [data.leerlingen.leerling];
     }
     const pupils = data.leerlingen.leerling;

     pupils.forEach((pupil) => {
      //add group info
      const pupilGroupKey = pupil.groep.key.key;
      const pupilGroup = content.groepen.groep.find(
       (groep) => groep.key.key === pupilGroupKey
      );
      pupil.groep = pupilGroup;

      //add composedGroup info
      if (pupil.samengestelde_groepen) {
       if (!Array.isArray(pupil.samengestelde_groepen.samengestelde_groep)) {
        pupil.samengestelde_groepen.samengestelde_groep = [
         pupil.samengestelde_groepen.samengestelde_groep,
        ];
       }
       const pupilComposedGroups =
        pupil.samengestelde_groepen.samengestelde_groep;

       pupilComposedGroups.forEach((group) => {
        const pupilComposedGroupKey = group.key.key;
        const pupilGroup = content.groepen.samengestelde_groep.find(
         (groep) => groep.key.key === pupilComposedGroupKey
        );
        group.naam = pupilGroup.naam;
        group.omschrijving = pupilGroup.omschrijving;
       });
      } else if (pupil.subgroepen) {
       if (!Array.isArray(pupil.subgroepen.groep)) {
        pupil.subgroepen.groep = [pupil.subgroepen.groep];
       }
       const pupilComposedGroups = pupil.subgroepen.groep;

       pupilComposedGroups.forEach((group) => {
        const pupilComposedGroupKey = group.key.key;
        const pupilGroup = content.groepen.samengestelde_groep.find(
         (groep) => groep.key.key === pupilComposedGroupKey
        );
        group.naam = pupilGroup.naam;
        group.omschrijving = pupilGroup.omschrijving;
       });
      }

      content.leerlingen.leerling.push(new Leerling(pupil));
     });
    } else {
     this.$toast.info("Geen Leerlingen ingelezen");
    }

    //-----------------Teachers
    content.leerkrachten = { leerkracht: [] };
    if (data.leerkrachten) {
     if (!Array.isArray(data.leerkrachten.leerkracht)) {
      data.leerkrachten.leerkracht = [data.leerkrachten.leerkracht];
     }
     const teachers = data.leerkrachten.leerkracht;

     teachers.forEach((teacher) => {
      //add group info
      if (teacher.groepen) {
       if (!Array.isArray(teacher.groepen.groep)) {
        teacher.groepen.groep = [teacher.groepen.groep];
       }
       

       if (!Array.isArray(teacher.groepen.samengestelde_groep) && teacher.groepen.samengestelde_groep !== undefined) {
         teacher.groepen.samengestelde_groep = [
          teacher.groepen.samengestelde_groep,
         ];
        }

       const teacherGroups = teacher.groepen.groep;
       const teacherComposedGroups = teacher.groepen.samengestelde_groep;
       const tempGroup = [];
       const tempComposedGroup = [];


       teacherGroups.forEach((group) => {
        const teacherGroupKey = group.key.key;
        const teacherGroup = content.groepen.groep.find(
         (groep) => groep.key.key === teacherGroupKey
        );
        tempGroup.push(teacherGroup);
       });
       teacher.groepen = { groep: tempGroup };

       if (teacherComposedGroups) {
        teacherComposedGroups.forEach((composedGroup) => {
         const teacherComposedGroupKey = composedGroup.key.key;
         const teacherComposedGroup = content.groepen.samengestelde_groep.find(
          (groep) => groep.key.key === teacherComposedGroupKey
         );
         tempComposedGroup.push(teacherComposedGroup);
        });
        teacher.groepen = {
         ...teacher.groepen,
         samengestelde_groep: tempComposedGroup,
        };
       }
      }

      if (teacher.subgroepen) {
       if (!Array.isArray(teacher.subgroepen.groep)) {
        teacher.subgroepen.groep = [teacher.subgroepen.groep];
       }
       const teacherComposedGroups = teacher.subgroepen.groep;
       const tempSubgroup = [];

       teacherComposedGroups.forEach((group) => {
        const teacherComposedGroupKey = group.key.key;
        const teacherGroup = content.groepen.samengestelde_groep.find(
         (groep) => groep.key.key === teacherComposedGroupKey
        );
        tempSubgroup.push(teacherGroup);
       });
       teacher.subgroepen = { groep: tempSubgroup };
      }

      content.leerkrachten.leerkracht.push(new Leerkracht(teacher));
     });
    } else {
     this.$toast.info("Geen Leerkrachten ingelezen");
    }

    const correctOrder = {
     school: content.school,
     groepen: content.groepen,
     leerlingen: content.leerlingen,
     leerkrachten: content.leerkrachten,
    };
    this.$emit("content", correctOrder);
   } else {
    this.$toast.error("Dit bestand heeft niet de juiste structuur");
   }
  },
  remodelJSONContent(data) {
   data = JSON.parse(data);

   // clone data to workable content
   let content = { ...data };

   //-----------------school
   if (data.school) {
    content.school = new School(content.school);
   } else {
    content.school = new School({});
   }

   //-----------------groups
   content.groepen = { groep: [], samengestelde_groep: [] };
   if (data.groepen) {
    const groups = data.groepen;

    groups.forEach((group) => {
     const tempKey = group.key;
     group.key = tempKey;
     content.groepen.groep.push(new Groep(group));
    });
   } else {
    this.$toast.info("Geen Groepen ingelezen");
    // TODO: initialize empty group
   }

   //-----------------Composed groups (subgroepen)
   if (data.subgroepen) {
    const subgroups = data.subgroepen;

    subgroups.forEach((subgroup) => {
     const tempKey = subgroup.key;
     subgroup.key = tempKey;
     content.groepen.samengestelde_groep.push(new SamengesteldeGroep(subgroup));
    });
    delete content.subgroepen;
   } else {
    // TODO: initialize empty subgroup
   }

   //-----------------Pupils
   content.leerlingen = { leerling: [] };
   if (data.leerlingen) {
    if (!Array.isArray(data.leerlingen)) {
     data.leerlingen = [data.leerlingen];
    }
    const pupils = data.leerlingen;

    pupils.forEach((pupil) => {
     //add group info
     const pupilGroupKey = pupil.groep;
     const pupilGroup = content.groepen.groep.find(
      (groep) => groep.key.key === pupilGroupKey
     );
     pupil.groep = pupilGroup;

     //add composedGroup info
     if (pupil.subgroepen) {
      if (!Array.isArray(pupil.subgroepen)) {
       pupil.subgroepen = [pupil.subgroepen];
      }
      const pupilComposedGroups = pupil.subgroepen;
      pupil.subgroepen = [];
      const tempSubgroup = [];

      pupilComposedGroups.forEach((subgroup) => {
       const pupilComposedGroupKey = subgroup;
       const pupilGroup = content.groepen.samengestelde_groep.find(
        (groep) => groep.key.key === pupilComposedGroupKey
       );
       tempSubgroup.push(pupilGroup);
      });
      pupil.subgroepen = { groep: tempSubgroup };
     }

     content.leerlingen.leerling.push(new Leerling(pupil, "json"));
    });
   } else {
    this.$toast.info("Geen Leerlingen ingelezen");
    // TODO: initialize empty pupils
   }

   //-----------------Teachers
   content.leerkrachten = { leerkracht: [] };
   if (data.leerkrachten) {
    if (!Array.isArray(data.leerkrachten)) {
     data.leerkrachten = [data.leerkrachten];
    }
    const teachers = data.leerkrachten;

    teachers.forEach((teacher) => {
     //add group info
     if (teacher.groepen.length) {
      if (!Array.isArray(teacher.groepen)) {
       teacher.groepen = [teacher.groepen];
      }

      const teacherGroups = teacher.groepen;
      const tempGroup = [];

      teacherGroups.forEach((group) => {
       const teacherGroupKey = group;
       const teacherGroup = content.groepen.groep.find(
        (groep) => groep.key.key === teacherGroupKey
       );

       tempGroup.push(teacherGroup);
      });
      teacher.groepen = { groep: tempGroup };
     }

     //add composedGroup info
     if (teacher.subgroepen) {
      if (!Array.isArray(teacher.subgroepen)) {
       teacher.subgroepen = [teacher.subgroepen];
      }
      const teacherComposedGroups = teacher.subgroepen;
      teacher.subgroepen = [];
      const tempSubgroup = [];

      teacherComposedGroups.forEach((subgroup) => {
       const teacherComposedGroupKey = subgroup;
       const teacherGroup = content.groepen.samengestelde_groep.find(
        (groep) => groep.key.key === teacherComposedGroupKey
       );
       tempSubgroup.push(teacherGroup);
      });
      teacher.subgroepen = { groep: tempSubgroup };
     }

     content.leerkrachten.leerkracht.push(new Leerkracht(teacher, "json"));
    });
   } else {
    this.$toast.info("Geen Leerlingen ingelezen");
    // TODO: initialize empty teachers
   }
   const correctOrder = {
    school: content.school,
    groepen: content.groepen,
    leerlingen: content.leerlingen,
    leerkrachten: content.leerkrachten,
   };
   this.$emit("content", correctOrder);
  },
 },
};
</script>
